import LogRocket from "logrocket";
import setupLogRocketReact from "logrocket-react";
import { axiosPrivate } from "../../api/axios";
export default {
    init,
    login,
    logout,
};
function logout() {
    LogRocket.startNewSession();
}
function init() {
    LogRocket.init("qp19gk/mealtrackmulti", {
        mergeIframes: true,
        network: {
            requestSanitizer: (request) => {
                return sanitizeRequest(request);
            },
        },
    });
    login();
    setupLogRocketReact(LogRocket);
}
function login() {
    axiosPrivate
        .get("/LogRocket")
        .then((res) => {
        if (res && res.data) {
            if (res.data.start_new_session) {
                LogRocket.startNewSession();
            }
            if (res.data.id) {
                if (res.data.user_data) {
                    LogRocket.identify(res.data.id, res.data.user_data);
                }
                else {
                    LogRocket.identify(res.data.id);
                }
            }
            if (res.data.event_name) {
                LogRocket.track(res.data.event_name, res.data.event_properties);
            }
        }
    })
        .catch((error) => {
        return;
    });
}
function sanitizeRequest(request) {
    const REDACT_FIELDS = ["password"];
    if (request && request.body) {
        try {
            const parsedBody = typeof request.body === "string" ? JSON.parse(request.body) : request.body;
            const redactedBody = redactFields(parsedBody, REDACT_FIELDS);
            request.body = typeof request.body === "string" ? JSON.stringify(redactedBody) : redactedBody;
        }
        catch (_a) {
            // If parsing fails, leave as is
        }
    }
    return request;
}
function redactFields(obj, fields) {
    if (Array.isArray(obj)) {
        return obj.map((item) => redactFields(item, fields));
    }
    if (obj && typeof obj === "object") {
        // Check if any redact field is a substring of the key (case-insensitive)
        // This catches fields like "password", "userPassword", "PASSWORD_RESET", etc.
        return Object.fromEntries(Object.entries(obj).map(([key, value]) => [
            key,
            fields.some((f) => key.toLowerCase().includes(f.toLowerCase())) ? "[REDACTED]" : redactFields(value, fields),
        ]));
    }
    return obj;
}
